import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
const points = ['Llegas a una sesión sin saber por dónde comenzar', 'Buscas información en distintas fuentes mientras preparas el espacio', 'Eliges cristales solo por intuición, sin tener una guía de consulta a mano', 'No tienes una estructura clara para abrir, desarrollar y cerrar una sesión', 'Te cuesta registrar qué hiciste en cada encuentro', 'No sabes qué revisar antes de combinar determinadas piedras', 'Terminas la jornada sin una rutina personal de cierre', 'Tienes materiales y conocimientos, pero no un método que los reúna', 'Quieres avanzar, pero cada sesión parece empezar desde cero'];
export function PainPoints() {
  return <Section className="max-w-4xl" data-id="element-232" data-mp="1szpslx2c11vn">
      <div className="mb-12 text-center" data-id="element-233" data-mp="1t0r6saena4hl">
        <h2 className="mb-6 font-display text-3xl font-bold leading-tight text-brand-purpleDark md:text-5xl" data-id="element-234" data-mp="3id3549kllw7u">
          ¿Cuántas sesiones más vas a preparar buscando información en distintos lugares?
        </h2>
        <p className="mx-auto mb-4 max-w-2xl text-sm leading-relaxed text-brand-text md:text-base" data-id="element-235" data-mp="1yzn3xk05p8g3">
          Te gustan los cristales. Has leído sobre sus significados. Tal vez ya tienes varias piedras, guardas
          publicaciones, ves videos y sabes que cada cristal puede acompañar una intención.
        </p>
        <p className="mx-auto mb-4 max-w-2xl text-sm leading-relaxed text-brand-text md:text-base" data-id="element-236" data-mp="23soljzrqzm3d">
          Pero hay una diferencia importante entre tener información y contar con un sistema para utilizarla con orden.
        </p>
        <p className="mx-auto max-w-2xl text-sm font-bold leading-relaxed text-brand-text md:text-base" data-id="element-237" data-mp="1b4spmxa05y7n">
          Conocer algunas propiedades de los cristales no es lo mismo que tener una guía clara para elegirlos,
          prepararlos, consultarlos y acompañar una sesión con estructura.
        </p>
        <p className="mt-6 font-serif text-lg font-semibold italic text-brand-goldDark md:text-xl" data-id="element-238" data-mp="30jh3z425lq8b">
          Y esa diferencia se siente antes de cada encuentro.
        </p>
      </div>

      <div className="glass-panel mb-12 rounded-3xl border-brand-purple/20 p-6 md:p-10" data-id="element-239" data-mp="1t79col36jmu4">
        <h3 className="mb-6 flex items-center font-serif text-base font-bold text-brand-purpleDark md:text-lg" data-id="element-240" data-mp="1y2ex1fgxotg3">
          <XIcon className="mr-2 h-6 w-6 shrink-0 text-brand-goldDark" data-id="element-241" data-mp="223qolqjdboqx" />
          LO QUE PASA CUANDO NO HAY UN SISTEMA CLARO
        </h3>
        <ul className="space-y-4" data-id="element-242" data-mp="1af72nsl1n4su">
          {points.map(point => <li key={point} className="flex items-start" data-id="element-243" data-mp="1acklr2c9jcxy">
              <XIcon className="mr-3 mt-0.5 h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-244" data-mp="1ehaieteqwvjx" />
              <span className="text-sm leading-relaxed text-brand-text md:text-base" data-id="element-245" data-mp="1jetubmnz0w8p">{point}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-246" data-mp="1o7mya8bm80jq">
        <h3 className="font-display text-2xl font-bold text-brand-purple md:text-3xl" data-id="element-247" data-mp="qqo80vh9qz6r">
          ¿Y SI ESTA FUERA LA ÚLTIMA SESIÓN QUE PREPARAS ASÍ?
        </h3>
      </div>
    </Section>;
}